var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErpServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M62,60c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V4c0-1.104,0.896-2,2-2h56c1.104,0,2,0.896,2,2V60z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60,0H4C1.789,0,0,1.789,0,4v56c0,2.211,1.789,4,4,4h56c2.211,0,4-1.789,4-4V4C64,1.789,62.211,0,60,0z  M62,60c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V4c0-1.104,0.896-2,2-2h56c1.104,0,2,0.896,2,2V60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M35,8h-6c-0.553,0-1,0.447-1,1v47h8V9C36,8.447,35.553,8,35,8z M34,54h-4V40h4V54z M34,38h-4V10h4V38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M25,16h-6c-0.553,0-1,0.447-1,1v39h8V17C26,16.447,25.553,16,25,16z M24,54h-4V44h4V54z M24,42h-4V18h4 V42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M55,24h-6c-0.553,0-1,0.447-1,1v31h8V25C56,24.447,55.553,24,55,24z M54,54h-4V44h4V54z M54,42h-4V26h4 V42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M45,32h-6c-0.553,0-1,0.447-1,1v23h8V33C46,32.447,45.553,32,45,32z M44,54h-4v-6h4V54z M44,46h-4V34h4 V46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M15,24H9c-0.553,0-1,0.447-1,1v31h8V25C16,24.447,15.553,24,15,24z M14,54h-4v-6h4V54z M14,46h-4V26h4V46 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    fill: "#B4CCB9",
    width: 4,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    fill: "#45AAB8",
    width: 4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    fill: "#F76D57",
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    fill: "#45AAB8",
    width: 4,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26,
    fill: "#B4CCB9",
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    fill: "#45AAB8",
    width: 4,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 48,
    fill: "#B4CCB9",
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    fill: "#F76D57",
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 44,
    fill: "#B4CCB9",
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 44,
    fill: "#45AAB8",
    width: 4,
    height: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 4,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 48,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 44,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 44,
    width: 4,
    height: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpServices);
export default __webpack_public_path__ + "static/media/erp-services.b93b2db4a001bad221eae5620f5b2810.svg";
export { ForwardRef as ReactComponent };